import { ActivityOverview } from './components/ActivityOverview';
import { AppShell } from './components/AppShell';
import { ControlReadiness } from './components/ControlReadiness';
import { buildActivityMetrics, syntheticPortalActivity } from './data/portal-model';

const metrics = buildActivityMetrics(syntheticPortalActivity);

export function App() {
  return (
    <AppShell>
      <ActivityOverview activity={syntheticPortalActivity} metrics={metrics} />
      <ControlReadiness />
    </AppShell>
  );
}
